
import React from 'react';

const AnimatedBackground: React.FC = () => {
  return (
    <div className="fixed inset-0 -z-10">
      <div className="absolute inset-0 bg-[#192035]" />
      <div className="absolute top-1/4 right-1/4 w-96 h-96 rounded-full bg-gradient-radial from-neon-purple/20 via-transparent to-transparent animate-pulse-soft" />
      <div className="absolute bottom-1/3 left-1/3 w-80 h-80 rounded-full bg-gradient-radial from-neon-blue/15 via-transparent to-transparent animate-pulse-soft" style={{ animationDelay: '1s' }} />
      <div className="absolute inset-0 bg-circuit-pattern opacity-3 -z-10" />
      <div className="absolute inset-0 bg-cyber-grid bg-[length:50px_50px] opacity-3 -z-10" />
    </div>
  );
};

export default AnimatedBackground;
